export default __webpack_public_path__ + "images/gw-logo.png?399af5b06a5e4dbbd1e2c67329b5a0e1";